import { Injectable } from '@angular/core';
import { AuthHttp } from '@http';
import { Config } from '@config';
import { UrlEnhancerService } from '@url';
import { PropertyConverter } from '@converter';
import { map } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';
import { __i18n } from '@localisation';



@Injectable()
export class LicenseService {

    constructor(
        private http : AuthHttp,
        private config : Config,
        private urlEnhancer : UrlEnhancerService,
        private propertyConverter : PropertyConverter
    ){}

    public async addNewActivationKey(key : string){
        return lastValueFrom(this.http.post(this.urlEnhancer.replaceParams(this.config.services.license.addActivationKey), {
            activationKey : key
        }));
    }

    public async addNewActivationId(activationKey: string, activationId: string){
        return lastValueFrom(this.http.post(this.urlEnhancer.replaceParams(this.config.services.license.addActivationId, {
            activationkey: activationKey
        }), {
            activationId
        }));
    }

    public async validateActivationId(activationKey: string, activationId: string) {
        return lastValueFrom(this.http.getJSON(this.urlEnhancer.replaceParams(this.config.services.license.validateActivationId, {
            activationkey: activationKey,
            activationid: activationId
        })));
    }

    public async getActivationId(){
        return lastValueFrom(this.http.getJSON(
                this.urlEnhancer.replaceParams(this.config.services.license.licenseDetails)
            ).pipe(map(this.propertyConverter.convertToCamelCase.bind(this.propertyConverter)))
        )
    }

    public downloadActivationKey() {
        document.location.href = this.urlEnhancer.replaceParams(this.config.services.license.download);
    }


    public getErrorTextFromCode(code: number) {
        switch(code){
            case -2:
                return __i18n(
                    'The request is invalid: the activation id is not activateable',
                    'license.list.activation-id-not-activateable.error.message'
                );
            case -3:
                return __i18n(
                    'The request is invalid: the activation id contains no new features',
                    'license.list.activation-id-no-newfeatures.error.message'
                );
            case -4:
                return __i18n(
                    'The request is invalid: the activation key cannot be found',
                    'license.list.activation-key-not-found.error.message'
                );
            case -5:
                return __i18n(
                    'The request is invalid: the activation id could not be found',
                    'license.list.activation-id-not-found.error.message'
                )
            case -6:
                return __i18n(
                    'The request is invalid: Unable to add licenses from the given activation id',
                    'license.list.activation-id-unable-to-add-licenses.error.message'
                )
            default:
                return '';
        }
       
    }

}